module.exports = __webpack_public_path__ + "media/entities/2210-9320063b.png";